<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Cronjobs</h1>

		<div class="margin-top margin-bottom">
			<button
				:disabled="saving"
				v-on:click="clean('subscriptions')"
				class="small small-margin-right">
					Move subscriptions away
					<div class="note">
						With renewal +/- 10 days
					</div>
				</button>
			<button
				:disabled="saving"
				v-on:click="clean('calls')"
				class="small">
					Move calls away
					<div class="note">
						Delete calls on today's date
					</div>
				</button>
		</div>

		<table>
			<thead>
				<tr>
					<th>Cronjob</th>
					<th>Description</th>
					<th></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="cronjob in cronjobs">
					<td>{{ cronjob.command }}</td>
					<td>{{ cronjob.description }}</td>
					<td>
						<button class="small" :disabled="saving" v-on:click="run(cronjob.command)">Run</button>
					</td>
				</tr>
			</tbody>
		</table>

	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    loading: false,
    saving: false,
    cronjobs: []
  }),
  methods: {
    load () {
      Vue.$api.get('/testing/cronjobs', {}, {
        loader: toggle => this.loading = toggle,
        callback: data => this.cronjobs = data
      })
    },

    run (command) {
      Vue.$api.post('/testing/cronjob/' + command, {}, {
        loader: toggle => this.saving = toggle
      })
    },

    clean (command) {
      Vue.$api.post('/testing/cronjob/clean/' + command, {}, {
        loader: toggle => this.saving = toggle
      })
    }
  },
  created () {
    this.load()
  }
}
</script>
